export const OWNER_NUMBER = "919560906643"
export const OWNER_EMAIL = "shivaenterprises52013@gmail.com"
